import PropTypes from 'prop-types';
import React from 'react';
import { localize } from '../i18n';

const Priority = function Priority(props) {
  const {
    priority,
  } = props;
  let priorityDisplay = '';
  switch (priority) {
    case 1:
      priorityDisplay = 'High';
      break;
    case 2:
      priorityDisplay = 'Immediate';
      break;
    default:
      priorityDisplay = 'Normal';
  }
  return (<span> {props.t(priorityDisplay)} </span>);
};

Priority.propTypes = {
  priority: PropTypes.number,
  t: PropTypes.func.isRequired,
};

export default localize(Priority);



// WEBPACK FOOTER //
// ./src/components/Priority.js